<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="product"
          :loading="loading"
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="productForm"
          :redirect-detail="true"
          :show-add-button="true"
          caption="<i class='fa fa-align-justify'></i> Produk Listing"
          addButton="Tambah Produk"
          @editForm="editForm"
          @resetForm="resetForm"
        ></global-table>
      </b-col>

      <b-modal
        ref="myModalRef"
        id="addModals"
        header-border-variant="no-border text-center"
        footer-border-variant="no-border"
        footer-bg-variant="light"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        size="lg"
      >
        <div slot="modal-header" class="text-center">
          <h3 class="text-center">Input Produk Baru</h3>
        </div>

        <b-form id="productForm" validated novalidate>
          <div v-if="!loadingSubmit">
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="name" label="Nama Produk">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.productForm.name.$model"
                    :state="!$v.productForm.name.$invalid"
                    required
                    placeholder="Nama Produk"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama Produk harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="product_group" label="Group Produk">
                  <model-select
                    id="product_group"
                    :options="listProductGroup"
                    v-model="$v.productForm.product_group.$model"
                    :isError="$v.productForm.product_group.$invalid"
                    placeholder="-- Harap pilih salah satu --"
                    required
                  ></model-select>
                  <div
                    v-if="productForm.product_group === null"
                    class="invalid-feedback-custom"
                  >Group Produk harus di pilih.</div>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="maximum_side_heap" label="Tumpukan Maksimal">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.productForm.maximum_side_heap.$model"
                    :state="!$v.productForm.maximum_side_heap.$invalid"
                    placeholder="Tumpukan Maksimal"
                  ></b-form-input>
                  <b-form-invalid-feedback>Tumpukan Maksimal harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group label-for="qty_box_each_line" label="Total Box Per-Baris">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.productForm.qty_box_each_line.$model"
                    :state="!$v.productForm.qty_box_each_line.$invalid"
                    placeholder="Total Box Per-Baris"
                  ></b-form-input>
                  <b-form-invalid-feedback>Total Box Per-Baris harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
              
            <b-row>
              <b-col sm="3">
                <b-form-group label-for="qty_each_box" label="Jumlah Dalam 1 Box">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.productForm.qty_each_box.$model"
                    :state="!$v.productForm.qty_each_box.$invalid"
                    placeholder="Jumlah Dalam 1 Box"
                  ></b-form-input>
                  <b-form-invalid-feedback>Jumlah Dalam 1 Box harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label-for="name" label="Nama Produk PO Indomaret">
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="$v.productForm.name_for_idm.$model"
                    :state="!$v.productForm.name_for_idm.$invalid"
                    placeholder="Nama Produk PO Indomaret"
                  ></b-form-input>
                  <b-form-invalid-feedback>Nama Produk PO Indomaret harus di isi.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <loading></loading>
          </div>
        </b-form>

        <div slot="modal-footer" class="float-right">
          <div v-if="!loadingSubmit">
            <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
              <i class="fa fa-undo"></i> Back
            </b-button>&nbsp;
            <b-button
              type="button"
              size="sm"
              variant="primary"
              @click="submitAdd"
              :disabled="$v.productForm.$invalid"
            >
              <i class="fa fa-save"></i> Save
            </b-button>
          </div>
        </div>
      </b-modal>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";

export default {
  name: "product",
  components: {
    globalTable,
    ModelSelect,
    loading
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      product: [],
      fields: [
        { key: "product_group_name", label: "Produk Grup", sortable: true},
        { key: "name", sortable: true },
        { key: "name_for_idm", label: "Nama Produk PO Indomaret", sortable: true },
        { key: "maximum_side_heap", label: "Tumpukan maksimal" },
        { key: "qty_box_each_line", label: "Total Box Per-Baris" },
        { key: "qty_each_box", label: "Total Setiap Box" },
        { key: "action", class: "text-center width-80" }
      ],
      listProductGroup: [],
      productForm: interfaces.product,
      loading: true,
      loadingSubmit: false
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    productForm: {
      name: { required },
      product_group: { required },
      name_for_idm: {},
      maximum_side_heap: {},
      qty_box_each_line: {},
      qty_each_box: {}
    }
  },
  methods: {
    init: function() {
      this.loading = true;
      this.getAllProduct();
      this.getDropdown();
    },
    getAllProduct() {
      this.axios
        .get("web/product/all/")
        .then(response => {
          this.product = response.data.data;
        })
        .catch(error => {
          this.expired(error, "Get product");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getDropdown() {
      this.axios
        .get("web/dropdown/dropdown-product-group/")
        .then(response => {
          this.listProductGroup = response.data.products_group;
        })
        .catch(error => {
          this.expired(error, "Get dropdown");
        })
        .finally(() => {
        });
    },
    editForm: function() {},
    resetForm: function() {
      for (var a in interfaces.product) {
        interfaces.product[a] = null;
      }
      this.productForm = interfaces.product;
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan produk ?")) {
        this.loadingSubmit = true;
        let product = this.productForm;
        product.employee_id = localStorage.getItem("employee_id");
        this.axios
          .post("web/product/add/", product)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Tambah Produk",
                message: response.data.message
              });
              this.$router.push({ path: "all/detail/" + response.data.id });
            }
          })
          .catch(error => {
            this.expired(error, "Add product");
          })
          .finally(() => {
              this.loadingSubmit = false;
          });
      }
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
